import React from "react";
import {
  CardContent,
  Typography,
  Box,
  Stack,
  Divider,
  Chip,
} from "@mui/material";
import { StyledCard } from "../common/StyledComponents";
import { castEnumForDisplay } from "../../helpers/enumHelpers";
import StatusChip from "../common/StatusChip";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import BusinessIcon from "@mui/icons-material/Business";
import VpnKeyIcon from "@mui/icons-material/VpnKey";

const ReminderLogCard = ({ log }) => {
  const sentDate = new Date(log.sentAt).toLocaleDateString();
  const sentTime = new Date(log.sentAt).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <StyledCard sx={{ borderLeft: "4px solid", borderLeftColor: "info.main" }}>
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">
              {castEnumForDisplay(log.type)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Sent on {sentDate} at {sentTime}
            </Typography>
          </Box>
          <StatusChip status={log.status} />
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={1.2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <BusinessIcon fontSize="small" color="action" />
            <Typography variant="body2" fontWeight="500" noWrap>
              {log.customerBusinessName}
            </Typography>
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center">
            <VpnKeyIcon fontSize="small" color="action" />
            <Typography variant="caption" sx={{ fontFamily: "monospace" }}>
              {log.licenseKey}
            </Typography>
          </Stack>

          <Box
            sx={{
              mt: 1,
              p: 1,
              bgcolor: "background.default",
              borderRadius: 1,
              border: "1px dashed",
              borderColor: "divider",
            }}
          >
            <Stack direction="row" spacing={1}>
              <NotificationsActiveIcon
                fontSize="inherit"
                color="disabled"
                sx={{ mt: 0.3 }}
              />
              <Typography variant="caption" color="text.secondary">
                {log.details || "No specific delivery details provided."}
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </CardContent>
    </StyledCard>
  );
};

export default ReminderLogCard;
